import React from 'react';

const UpwardAutoSuggestRedux = ({
   input, label, className,
   meta: { touched, error },
   component: Component,
   childComponent: ChildComponent,
   ...custom
}) => {
   return (
      <ChildComponent
         {...custom}
         {...input}
         className={(className ? className : '') + ' ' + (touched && error ? " is-invalid " : "")}
         selected={input.value}
         onSelection={input.onChange}
      />
   )
}

export default UpwardAutoSuggestRedux;
